var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmacionWhastapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #72b7a4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m90,180C40.37,180,0,139.63,0,90S40.37,0,90,0s90,40.38,90,90-40.37,90-90,90Zm0-158.07c-37.53,0-68.07,30.54-68.07,68.07s30.54,68.07,68.07,68.07,68.07-30.54,68.07-68.07S127.53,21.93,90,21.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.67,134.7l-54.29-57.38,17.29-16.36,34.09,36.03c9.35-13.4,18.91-26.76,28.51-39.84,12.75-17.37,26-34.85,39.4-51.94l18.73,14.68c-13.24,16.89-26.34,34.17-38.94,51.34-12.34,16.82-24.61,34.09-36.45,51.33l-8.34,12.14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmacionWhastapp);
export default __webpack_public_path__ + "static/media/ConfirmacionWhastapp.97a7e2a878eaef0e0d161429ae76a16f.svg";
export { ForwardRef as ReactComponent };